"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationsService = void 0;
const api_1 = require("./api");
const PATH = 'content/api';
class RecommendationsService {
    static async getRecommendations(filterParams) {
        let requestParams = [];
        if (filterParams && filterParams.length > 0) {
            requestParams = [...requestParams, ...filterParams];
        }
        const requestUrl = `${PATH}/recommendations?${requestParams.join('&')}`;
        try {
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
}
exports.RecommendationsService = RecommendationsService;
//# sourceMappingURL=recommendations-service.js.map